import PropTypes from "prop-types";
import React from "react";
import { Select } from "cxa-components";
import FormField from "./FormField";

const SelectField = ({ items, valueKey = "value", labelKey = "label", ...props }) => (
  <FormField component={Select} {...props}>
    {items.map((item, idx) => (
      <option key={`${item[valueKey]}-${idx}`} value={item[valueKey]}>
        {item[labelKey]}
      </option>
    ))}
  </FormField>
);

SelectField.propTypes = {
  items: PropTypes.array,
  valueKey: PropTypes.string,
  labelKey: PropTypes.string,
};

export default SelectField;



// WEBPACK FOOTER //
// ./components/common/form-field/SelectField.js